import axiosCore from '../common/axiosCore';

const memberNoKey = 'memberNo';
const vTokenKey = 'vToken';
const keyUser = 'userProfile';
const memberKey = 'memberProfile';
const schemeKey = 'schemeList';
const avatarKey = 'avatar';
const statementKey = 'statement';
const dependentKey = 'dependent';
const signatureKey = 'sign';
const dojKey = 'doj';
const eligibleKey = 'eligible';

const registeredUsers = new Map([
  ['admin', {
    id: 'uid:0', username: 'admin', email: 'admin@example.com', password: 'qwerty', firstname: 'App', lastname: 'Admin',
  }],
  ['lee', {
    id: 'uid:973236115', username: 'lee', email: 'lee@acme.com', password: '12345', firstname: 'Steve', lastname: 'Lee',
  }],
]);

export default function setSession(userProfile, memberProfile, schemeList, token, profileAvatar, statement, dependent, sign, doj, eligible) {
  // Remove the password property.
  const { ID, ...rest } = userProfile;

  // Merge token to the final object.
  const merged = {
    ...rest,
    token,
  };
  // localStorage.setItem(vTokenKey, JSON.stringify(merged));
  localStorage.setItem(keyUser, JSON.stringify(merged));
  localStorage.setItem(memberKey, JSON.stringify(memberProfile));
  localStorage.setItem(schemeKey, JSON.stringify(schemeList));
  localStorage.setItem(avatarKey, JSON.stringify(profileAvatar));
  localStorage.setItem(statementKey, JSON.stringify(statement));
  localStorage.setItem(dependentKey, JSON.stringify(dependent));
  localStorage.setItem(signatureKey, JSON.stringify(sign));
  localStorage.setItem(dojKey, JSON.stringify(doj));
  localStorage.setItem(eligibleKey, JSON.stringify(eligible));
}

function getSession() {
  const user = localStorage.getItem(keyUser);
  return JSON.parse(user);
}

function getMemberProfile() {
  const memberProfile = localStorage.getItem(memberKey);
  return JSON.parse(memberProfile);
}

function getEligibleBenefit() {
  const eligibleBenefit = localStorage.getItem(eligibleKey);
  return JSON.parse(eligibleBenefit);
}

function getSchemeList() {
  const schemeList = localStorage.getItem(schemeKey);
  return JSON.parse(schemeList);
}

function getProfileAvatar() {
  const profileAvatar = localStorage.getItem(avatarKey);
  return JSON.parse(profileAvatar);
}

function getStatement() {
  const statement = localStorage.getItem(statementKey);
  return JSON.parse(statement);
}

function getDependent() {
  const dependent = localStorage.getItem(dependentKey);
  return JSON.parse(dependent);
}

function getSignature() {
  const sign = localStorage.getItem(signatureKey);
  return JSON.parse(sign);
}

function getDoj() {
  const doj = localStorage.getItem(dojKey);
  return JSON.parse(doj);
}

function getMemberNo() {
  const memberNo = localStorage.getItem(memberNoKey);
  return JSON.parse(memberNo);
}

function getVToken() {
  const vToken = localStorage.getItem(vTokenKey);
  return JSON.parse(vToken);
}

function isAuth() {
  return !!getSession();
}

async function login(username, password) {
  const wrongAttempt = localStorage.getItem('wrongAttempt');
  return new Promise((resolve, reject) => {
    // Using setTimeout to simulate network latency.
    setTimeout(() => {
      axiosCore.post('/member-module/user/login', {
        USERNAME: username,
        PWD: password,
      }).then((result) => {
        if (result.data.status === 1) {
          const token = result.data.auth_token;
          const userProfile = result.data.data.user_profile;
          const memberProfile = result.data.data.member_details;
          const schemeList = result.data.data.scheme_list;
          const profileAvatar = result.data.data.avatar;
          const sn = result.data.data.signature;
          const dj = result.data.data.doj;
          const eb = result.data.eligible_benefit;
          const s = result.data.statement;
          const dependant = result.data.data.dependants;
          setSession(userProfile, memberProfile, schemeList, token, profileAvatar, s, dependant, sn, dj, eb);
          localStorage.removeItem('invalidLoginMemberID');
          localStorage.removeItem('wrongAttempt');
          return resolve(token);
        }
        if (result.data.status === 0) {
          localStorage.setItem('invalidLoginMemberID', username);
          const invalidLoginMemberID = localStorage.getItem('invalidLoginMemberID');
          if (wrongAttempt === null) {
            localStorage.setItem('wrongAttempt', 1);
            return reject(new Error('Unsuccessful login, you have a maximum of 3 tries'));
          }
          if (username === invalidLoginMemberID) {
            if (wrongAttempt <= 3) {
              const attempts = parseInt(wrongAttempt, 2) + 1;
              localStorage.setItem('wrongAttempt', attempts);
              const remainingAttempts = 4 - attempts;
              return reject(new Error(`Unsuccessful login, you have a maximum of ${remainingAttempts} tries`));
            }
            return reject(new Error('Locked out, you have exceed maximum tries'));
          }
          localStorage.setItem('wrongAttempt', 1);
          return reject(new Error('Unsuccessful login, you have a maximum of 3 tries'));
        }
        return reject(new Error('An Error occurred, Please try again.'));
      }).catch((err) => {
        reject(new Error(err));
      });
    }, 2000);
  });
}

async function addUser(user) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      axiosCore.post('/member-module/user/register', {
        MEMBER_ID: user.memberID,
        FIRST_NAME: user.firstName,
        MIDDLE_NAME: '',
        LAST_NAME: user.lastName,
        DATE_OF_BIRTH: user.dateOfBirth,
        MOBILE_NUMBER: user.phoneNumber,
        NATIONAL_ID: '',
        EMAIL: user.email,
        PWD: user.password,
      }).then((result) => {
        if (result.data.status !== 0) {
          return resolve();
        }
        if (result.data.status === 0) {
          // console.log(result.data.message);
        }
        return reject(new Error(result.data.message));
      }).catch((err) => {
        reject(new Error(err));
      });
    }, 1000);
  });
}

async function logout() {
  return new Promise((resolve) => {
    // Using setTimeout to simulate network latency.
    setTimeout(() => {
      localStorage.removeItem('_expiredTime');
      localStorage.removeItem(keyUser);
      localStorage.removeItem(memberKey);
      localStorage.removeItem(schemeKey);
      localStorage.removeItem(avatarKey);
      localStorage.removeItem(statementKey);
      localStorage.removeItem(dependentKey);
      localStorage.removeItem(signatureKey);
      localStorage.removeItem(dojKey);
      localStorage.clear();
      resolve();
    }, 1000);
  });
}

async function sendPasswordReset() {
  return new Promise((resolve) => {
    // Using setTimeout to simulate network latency.
    setTimeout(() => {
      resolve();
    }, 1000);
  });
}

async function verifyAccount(user, otp) {
  return new Promise((resolve, reject) => {
    // Using setTimeout to simulate network latency.
    setTimeout(() => {
      axiosCore.post('/member-module/user/verify-by-otp', {
        MEMBER_ID: user.memberID,
        OTP: otp,
      }).then((result) => {
        if (result.data.status !== 0) {
          return resolve();
        }
        if (result.data.status === 0) {
          // console.log(result.data.message);
        }
        return reject(new Error(result.data.message));
      }).catch((err) => {
        reject(new Error(err));
      });
    }, 1000);
  });
}

async function verifyForgotPassword(memberNo, otp) {
  return new Promise((resolve, reject) => {
    // Using setTimeout to simulate network latency.
    setTimeout(() => {
      axiosCore.post('/member-module/user/verify-by-otp', {
        MEMBER_ID: memberNo,
        OTP: otp,
      }).then((result) => {
        // console.log(result);
        if (result.data.status !== 0) {
          localStorage.setItem(vTokenKey, JSON.stringify(result.data.token));
          return resolve();
        }
        if (result.data.status === 0) {
          // console.log(result.data.message);
        }
        return reject(new Error(result.data.message));
      }).catch((err) => {
        reject(new Error(err));
      });
    }, 1000);
  });
}

async function resendCode(user) {
  return new Promise((resolve, reject) => {
    // Using setTimeout to simulate network latency.
    const phone = `255${user.phoneNumber}`;
    setTimeout(() => {
      axiosCore.post('/member-module/user/resend-verification-token', {
        MEMBER_ID: user.memberID,
        PHONE: phone,
      }).then((result) => {
        if (result.data.status !== 0) {
          return resolve();
        }
        if (result.data.status === 0) {
          // console.log(result.data.message);
        }
        return reject(new Error(result.data.message));
      }).catch((err) => {
        reject(new Error(err));
      });
    }, 1000);
  });
}

async function getUsers() {
  return new Promise((resolve) => {
    // Using setTimeout to simulate network latency.
    setTimeout(() => {
      const users = Array.from(registeredUsers.values());
      resolve(users);
    }, 1000);
  });
}

async function setPassword(memberNo, vToken, password) {
  return new Promise((resolve, reject) => {
    // Using setTimeout to simulate network latency.
    setTimeout(() => {
      axiosCore.post('/member-module/user/set-password', {
        MEMBER_ID: memberNo,
        TOKEN: vToken,
        PWD: password,
      }).then((result) => {
        if (result.data.status !== 0) {
          localStorage.removeItem(memberNoKey);
          localStorage.removeItem(vTokenKey);
          return resolve();
        }
        if (result.data.status === 0) {
          // console.log(result.data.message);
        }
        return reject(new Error(result.data.message));
      }).catch((err) => {
        reject(new Error(err));
      });
    }, 1000);
  });
}

async function forgotPassword(user) {
  return new Promise((resolve, reject) => {
    // Using setTimeout to simulate network latency.
    setTimeout(() => {
      const phone = `255${user.phoneNumber}`;
      axiosCore.post('/member-module/user/reset-password', {
        MEMBER_ID: user.memberID,
        PHONE: phone,
      }).then((result) => {
        if (result.data.status !== 0) {
          localStorage.setItem(memberNoKey, JSON.stringify(user.memberID));
          return resolve();
        }
        if (result.data.status === 0) {
          console.log(result.data.message);
        }
        return reject(new Error(result.data.message));
      }).catch((err) => {
        reject(new Error(err));
      });
    }, 1000);
  });
}

async function changePassword(memberNo, cPassword, nPassword) {
  return new Promise((resolve, reject) => {
    // Using setTimeout to simulate network latency.
    setTimeout(() => {
      axiosCore.post('/member-module/user/change-password', {
        MEMBER_ID: memberNo,
        CURRENT_PWD: cPassword,
        NEW_PWD: nPassword,
      }).then((result) => {
        if (result.data.status !== 0) {
          return resolve();
        }
        if (result.data.status === 0) {
          // console.log(result.data.message);
        }
        return reject(new Error(result.data.message));
      }).catch((err) => {
        reject(new Error(err));
      });
    }, 1000);
  });
}

async function updateNidaNo(memberNo, employerID, nidaNo, firstName, middleName, lastName, senderID) {
  return new Promise((resolve, reject) => {
    // Using setTimeout to simulate network latency.
    setTimeout(() => {
      axiosCore.post('/member-module/nida-update/update', {
        EMPLOYER_ID: employerID,
        MEMBER_ID: memberNo,
        NATIONAL_ID: nidaNo,
        FIRST_NAME: firstName,
        MIDDLE_NAME: middleName,
        LAST_NAME: lastName,
        SOURCE: 'MEMBERPORTAL',
        IS_VALIDATED: '0',
        IS_EMPLOYER: '0',
        MOBILE_PHONE: senderID,
        LANGUAGE: 'EN',
      }).then((result) => {
        if (result.data.status !== 0) {
          return resolve();
        }
        if (result.data.status === 0) {
          return resolve();
          // console.log(result.data.message);
        }
        return reject(new Error(result.data.message));
      }).catch((err) => {
        reject(new Error(err));
      });
    }, 1000);
  });
}

// The useAuth hook is a wrapper to this service, make sure exported functions are also reflected
// in the useAuth hook.
export {
  getSession,
  isAuth,
  login,
  logout,
  sendPasswordReset,
  verifyAccount,
  verifyForgotPassword,
  resendCode,
  forgotPassword,
  changePassword,
  addUser,
  getUsers,
  getMemberNo,
  getVToken,
  getProfileAvatar,
  getEligibleBenefit,
  getSchemeList,
  updateNidaNo,
  getMemberProfile,
  getStatement,
  getDependent,
  getDoj,
  getSignature,
  setPassword,
};
